import Link from "next/link";
import useFetchData from "../hooks/useFetchData";
import ImageProcessor from "./ImageProcessor";
import { KARATDAO_DEFAULT_SUPPORTED_CHAINS } from "@/chain-info/KaratDaoSupportedChain";

const CampaignRowItem = ({ campaign }: { campaign: any }) => {
  const { data: baseInfoURIData } = useFetchData(campaign?.baseInfoURI);
  const expectedChain = KARATDAO_DEFAULT_SUPPORTED_CHAINS.find(
    (network) => network.chainId === campaign?.chainId
  );
  const chainName = expectedChain?.chainName;
  return (
    <Link
      href={`/airdrops/${chainName}/${campaign?.type?.toLowerCase()}/${
        campaign.address
      }`}
      passHref
    >
      <a className="mb-3 flex w-full flex-col items-center justify-between rounded-lg bg-bg_blue1 text-dark1 px-6 py-4 action sm:flex-row">
        <div className="flex items-center" data-testid="campaign-item">
          <div className="relative">
            <ImageProcessor
              src={baseInfoURIData?.image}
              size="s300"
              className="mr-6 h-[85px] w-[85px] rounded-md object-cover"
            />
          </div>
          <div className="flex flex-col ">
            <div className="mb-1 font-bold text-sm">{campaign?.name}</div>
            <div className="mb-1 text-gray1 text-xs">Network: {chainName}</div>
            <div className="text-gray1 text-xs">
              Total Airdrop Supply: {campaign?.reach?.toString()}
            </div>
          </div>
        </div>

        <div className="sm::mt-0 mt-2 text-sm flex w-full justify-between sm:mr-10 sm:w-1/3 ">
          <div className="flex flex-col items-start space-y-3">
            <div>Total Claimed</div>
            <div className="font-bold">{campaign?.claimedNum?.toString()}</div>
          </div>
          <div className="flex flex-col items-start space-y-3">
            <div>Total Wallets</div>
            <div className="font-bold">{campaign?.reach?.toString()}</div>
          </div>
          <div className="flex flex-col items-start space-y-3">
            <div>Status</div>
            <div className="font-bold flex items-center">
              <div
                className={`w-[5px] h-[5px] rounded-full mr-1 mt-1 ${
                  campaign?.isActive ? "bg-[#259A08]" : "bg-[#FF5D5D]"
                }`}
              ></div>
              {campaign?.isActive ? "Active" : "Stopped"}
            </div>
          </div>
        </div>
      </a>
    </Link>
  );
};

export default CampaignRowItem;
